import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SizeAdd = () => {
  const navigate = useNavigate();
  const initialFormState = {
    size_label: "",
    size_name: "",
    status: "",
  };

  const [SizeUser, setSizeUser] = useState(initialFormState);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setSizeUser({ ...SizeUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_mst_prod_size",
        SizeUser
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "Size added successfully!");
        navigate("/size-list");
      } else {
        toast.error(response.data.error || "Failed to add data");
      }
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Size Master</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="#">Master</a>
                </li>
                <li className="breadcrumb-item active">Size Master</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Add Size Form */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h5>Add New Size</h5>
              </div>
              <form onSubmit={submitForm}>
                <div className="card-body">
                  <div className="mb-3">
                    <label className="form-label">Size Label</label>
                    <input
                      type="text"
                      className="form-control"
                      id="size_label"
                      name="size_label"
                      placeholder="e.g. S, M, L, XL"
                      value={SizeUser.size_label}
                      onChange={handleInput}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Size Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="size_name"
                      name="size_name"
                      placeholder="e.g. Small, Medium"
                      value={SizeUser.size_name}
                      onChange={handleInput}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      className="form-control"
                      id="status"
                      name="status"
                      value={SizeUser.status}
                      onChange={handleInput}
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                  <button className="btn btn-primary" type="submit">
                    Add Size
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeAdd;
